import MapionDatumUtil from '../../config/adapters';

let oldvias = [null, null, null, null, null];
const DriveResult = (
  { naviSearch, setNaviSearch, map, naviToggle, naviStart,naviEnd,setNaviURLParam, resultError, setResultError,
    naviVia1, naviVia2 ,naviVia3 ,naviVia4 ,naviVia5, setIsSmp, naviFromToggle, isTablet}
) => {
  const MILLISECONDS_PER_DEGREE = 60 * 60 * 1000; // minutes * seconds * milliseconds
  const ONE_OVER_MILLISECONDS_PER_DEGREE = 1 / MILLISECONDS_PER_DEGREE;
  const LINE_WIDTH = 8;
  const LINE_OPACITY = 0.80;
  const LINE_COLOR_HIGHWAY = '#00ab1c';
  const LINE_COLOR_GENERAL_ROAD = '#1e39f3';
  const LIST_COLOR_HIGHWAY = '#418e70';
  const LIST_COLOR_GENERAL_ROAD = '#6470c5';
  const HIGHWAY_SPEED = 80;
  const TOLL_ROAD_SPEED = 50;
  const GENERAL_ROAD_SPEED = 30;
  const REACT_APP_API_BLOCK_URL = process.env.REACT_APP_API_BLOCK_URL
  const SCROLL_DELAY_TIME = 300; // SP結果のスクロールで結果の開閉にアニメーションがあるので、それを考慮してスクロールを遅らせる値

  const convertPathToFromToPoint = (path) => {
    const paths = path.split(",");
    const [fromLon, fromLat] = paths;
    const [toLon, toLat] = paths.slice(-2);
    const convertPoint = (lon, lat) => {
      return {
        lon: lon * ONE_OVER_MILLISECONDS_PER_DEGREE || null,
        lat: lat * ONE_OVER_MILLISECONDS_PER_DEGREE || null,
      };
    };
    return {
      from: convertPoint(fromLon, fromLat),
      to: convertPoint(toLon, toLat),
    }
  }

  /*
  * 左カラムリストに表示するポイントかどうか判定する
  * @param info Object
  * @return Boolean
  */
  const isNodeMarkerListPoint = (info, beforeInfo) => {
    return isNodeMarker(info, beforeInfo) && info.link_type !== 15;
  }

  /*
  * データがポイントかどうか判定する
  * @param info Object
  * @return Boolean
  */
  const isNodeMarker = (info, beforeInfo) => {
    let direction = +info.direction; // stringなので数値化
    if (info.guide_illust_type){ // 画像取得が可能なガイドタイプであること
      if(direction > 30 && !(direction === 0 && /(ＩＣ|ランプ)/.test(info.cross_name) && +info.toll === 0)){ // ルート種別が0か1だった場合(高速道路、都市高速道路である)
        return true;
      }
    }
    if (direction > 30 && direction < 330){ // 角度が左右30度以上だった場合
      return true
    }
    if (info.cross_name || info.link_name){ // 交差点名、もしくは、ルート名があり
      if(+info.toll > 0){ // かつ、料金が0以上だった場合
        return true;
      }
    }
    if (beforeInfo && _isSwitchFromtHighwayToGeneral(info, beforeInfo)){
      return true;
    }
    if(_isSwitchFromtGeneralToHighway(info, beforeInfo)){
      return true;
    }
    if(/料金所/.test(info.cross_name)){
      return true;
    }
    return false;
  }

  /*
  * 一般道から高速道路に切り替わったか判定する
  * @info Object
  * @beforeInfo Object
  * return Bool
  */
  const _isSwitchFromtGeneralToHighway = (info, beforeInfo)=>{
    return (_isHighway(info) || _isTollRoad(info)) && !(_isHighway(beforeInfo) || _isTollRoad(beforeInfo))
  }

  /*
  * 高速道路から一般道に切り替わったか判定する
  * @info Object
  * @beforeInfo Object
  * return Bool
  */
  const _isSwitchFromtHighwayToGeneral = (info, beforeInfo) => {
    return (_isHighway(beforeInfo) || _isTollRoad(beforeInfo)) && !(_isHighway(info) || _isTollRoad(info))
  }

  /*
  * 高速道路か否かを判定する
  * @info Object
  * return Bool
  */
  const _isHighway = (info) => {
    return /^(0|1)$/.test(info.link_type);
  }

  /*
  * 有料道路か否かを判定する
  * @info Object
    * return Bool
  */
  const _isTollRoad = (info) => {
    return info.toll_link === "1";
  }

  // ポイント毎のタイプ名を返す
  const nodeMarkerTypeString = (info, beforeInfo)=>{
    let {cross_name, guide_type, link_type, link_name, guide_illust_type, direction} = info;
    direction = +direction;
    if(typeof cross_name === "string" && cross_name.indexOf("料金所") > -1){
      return "料金所"
    } else if(guide_type === "3"){
      return "ジャンクション";
    } else if(+link_type === 15){
      return "目的地付近";
    } else if(_isSwitchFromtGeneralToHighway(info, beforeInfo) ){
      if(link_type === "10"){
        return "フェリー";
      } else if(typeof link_name === "string"){
        return `${link_name} 入り口`;
      } else {
        return "高速入り口";
      } 
    } else if(_isSwitchFromtHighwayToGeneral(info, beforeInfo)){ // 高速から一般道になった時は何もメッセージを入れない
      return "";
    } else if(guide_illust_type && guide_illust_type === "1" ){
      return "ETCレーン案内";
    } else if(_isHighway(info) || _isTollRoad(info)){
      return "分岐";
    } else if(direction > 30 && direction < 330 && +link_type !== 15){
      return "交差点"
    } else {
      return "道なり";
    }
  }

  // 方向画像のための方向の記号を返す
  const nodeMarkerDirection = (direction)=>{
    let directionNum = +direction;
    directionNum = +direction;
    switch (false) {
      case !(directionNum < 30):
        return "f";
      case !(directionNum < 60):
        return "rf";
      case !(directionNum < 120):
        return "r";
      case !(directionNum < 180):
        return "rb";
      case !(directionNum < 240):
        return "lb";
      case !(directionNum < 300):
        return "l";
      case !(directionNum < 330):
        return "lf";
      default:
        return "f";
    }
  }

  // 高速道路上でのタイプを返す
  const nodeMarkerHighwayType = (info) => {
    if ((/料金所/.test(info.cross_name)) || +info.toll > 0) { // IPCデータ対策として料金がある場合は料金アイコンを表示してみる
      return "gate";
    } else if (/ＪＣＴ/.test(info.cross_name) || info.guide_type === "3") {
      return "jct";
    } else if (/ＩＣ/.test(info.cross_name)) {
      return "ic";
    } else {
      return "";
    }
  }

  // メートル表記をキロメートルに変える
  const meterToKmStr = (distance)=>{
    let numDistance = +distance;
    if(numDistance < 1000){
      return `${numDistance}m`;
    }else{
      let km = Math.ceil(((numDistance / 1000) * 10)) / 10;
      return `${km}km`;
    }
  }

  // 総距離の文言を返す
  const totalDistance = (links = []) => {
    let totalDistance = links.reduce((sumDistance, link)=>{
      return sumDistance + (link.info.link_type!=="15"
          ? +link.info.distance
          : 0)
    }, 0);
    return meterToKmStr(totalDistance);
  }

  // ルートの総経過時間を返す
  const getDriveTotalMinTime = (links = []) => {
    let totalMin = links.reduce((sumMin, {info})=>{
      let kmh = GENERAL_ROAD_SPEED
      if(_isHighway(info)){
        kmh = HIGHWAY_SPEED;
      } else if(_isTollRoad(info)){
        kmh = TOLL_ROAD_SPEED
      }
      let mm = (kmh/60) * 1000;
      let distance = +info.distance;
      return sumMin + (distance / mm)
    }, 0);
    return Math.ceil(totalMin);
  }

  // ◯時間◯分に文言を返す
  const hrsMnsToJiFunStr = ({hrs, mns}) => {
    return hrs > 0
      ? `${hrs}時間${mns}分`
      :`${mns}分`;
  }

  // ハンドラ関連
  // 左リストのポイントをクリックで中心に移動する
  const moveCenter = (e, lat, lon) => {
    let {currentTarget} = e;
    const $ = window.$;
    e.preventDefault();
    map.flyTo({center: [lon, lat]})

    if(isTablet){
      naviFromToggle(false, true, true); // SPの場合はフォーム閉じて地図表示しておく
      setTimeout(()=>{
        // SPの場合は選択した要素までスクロールしておく
        let offset = $(currentTarget).offset().top - $(".navi-result-component").offset().top;
        let scrollAmount = $(".navi-result-component").scrollTop();
        $(".navi-result-component").scrollTop(scrollAmount + offset);
      }, SCROLL_DELAY_TIME);
    }
  }

  // リスト部の道路名部をクリックすると前後のポイントの緯度経度から画面にフィットした表示位置に移動する
  const fitPointToPoint = (e) => {
    let {currentTarget} = e;
    const $ = window.$;
    let {lat: firstLat, lon: firstLon} = $(currentTarget).prev().data();
    let {lat: lastLat, lon: lastLon} = $(currentTarget).next().data();

    // 必ず min=西南 max=北東 にする ※これやらないとfitboundsでバグる
    let minLat = firstLat < lastLat? firstLat: lastLat;
    let minLon = firstLon < lastLon? firstLon: lastLon;
    let maxLat = firstLat > lastLat? firstLat: lastLat;
    let maxLon = firstLon > lastLon? firstLon: lastLon;

    let padding =  {top: 100, left: 500, bottom: 100, right:40};
    if(isTablet){
      padding=  {top: 160, left: 30, bottom: 260, right:80}; // SPの場合は範囲が狭いので余白を変える※上下左右の対象同士の値が画面の範囲を超えると全くうごかなくなるので
      naviFromToggle(false, true, true); // SPの場合は地図表示しておく
      setTimeout(()=>{
        // SPの場合は選択した要素までスクロールしておく
        let offset = $(currentTarget).offset().top - $(".navi-result-component").offset().top;
        let scrollAmount = $(".navi-result-component").scrollTop();
        $(".navi-result-component").scrollTop(scrollAmount + offset);
      }, SCROLL_DELAY_TIME);
    }

    map.fitBounds([[minLon, minLat], [maxLon, maxLat]],{
      padding
    });
  }


  const execSearch = () => {
    // ルート検索実行処理
    // パラメータを作る
    let params = Object.keys(naviSearch.drive).map(key => {
      return `${encodeURIComponent(key)}=${encodeURIComponent(naviSearch.drive[key])}`;
    });
    var start = naviStart;
    let {x: startX, y: startY} = MapionDatumUtil.wgs.tky({y: start.lat, x: start.lon});
    params.push(`sty=${startY}`);
    params.push(`stx=${startX}`);
    var end = naviEnd;
    let {x: endX, y: endY} = MapionDatumUtil.wgs.tky({y: end.lat, x: end.lon});
    params.push(`edy=${endY}`);
    params.push(`edx=${endX}`);
    params.push(`datum=TOKYO`);
    
    // 経由地の設定
    vias.filter((via)=>{ // mx1を飛ばしてmx2,my2から検索できないので、検索できる経由地のみに絞る
      if(via){
        let {name, lat, lon} = via;
        return name && lat && lon; //経由地が存在してname,lat,lonが存在するものだけに絞る
      }else {
        return false
      }
    }).forEach((via, idx)=>{
      let {name, lat, lon} = via;
      if(name && lat && lon){
        let index = idx+1;
        let {x, y} = MapionDatumUtil.wgs.tky({y: lat, x: lon});
        params.push(`mx${index}=${x}&my${index}=${y}&mt${index}=0`);
      }
    });

    let url = `${REACT_APP_API_BLOCK_URL}/map/uc/SearchRoute?${params.join('&')}`;
    if(!window.jqXHR) { // まだリクエストが走っていない場合のみ実行
      window.jqXHR = window.$.ajax({
        url: url,
        dataType: 'jsonp',
        jsonpCallback: 'searchRouteCallback',
        success: function({route}) {
          let {links} = route;
          console.log("ルート検索結果データ:", links);
          // ここで結果を処理する
          const link = links?.link || []; // linkが存在しない場合は検索失敗してる可能性が高い
          let features = [];

          // こういうデータを作る 発G-----H----G----着 
          // geoJSONはG-H-Gのそれぞれのポリラインを作れば良い
          features = link.reduce(({links, beforeType}, {info, path}, idx)=>{
            if(idx === 0 || idx === (link.length - 1)){ // 出発地→最初のポイント と 最後のポイント→目的地 の線は引かない
              return {links, beforeType};
            }

            let type = "G";
            if(_isHighway(info)){
              type = "H";
            } else if(_isTollRoad(info)){
              type = "T";
            }

            // pathをwgsの緯度経度に変える
            let lines = path.split(",")
              .map(coord=> parseFloat(coord) * ONE_OVER_MILLISECONDS_PER_DEGREE)  // 60進数→10進数変換
              .reduce((acc, coord, index) => { // "x,y,x,y,x,y" のデータをlat,lonに切り分ける
                if (index % 2 === 0) {
                  acc.push([coord]);
                } else {
                  acc[acc.length - 1].push(coord); // 最後の配列に追加
                }
                return acc;
              }, []).map(([lon, lat]) => ({lat, lon}))
              .map(({lat, lon}) => { // 東京測地系→WGS84変換
                let {y, x} = MapionDatumUtil.tky.wgs({y: lat, x: lon});
                return [x, y];
              })

            if(beforeType !== type){ // 前後でタイプが異なる場合は色の違うポリラインを設定する
              links.push({ // geoJSONのポリラインを生成する
                type: "Feature",
                properties: {
                  "stroke": type === "H" || type === "T" ? LINE_COLOR_HIGHWAY: LINE_COLOR_GENERAL_ROAD,
                  "stroke-width": LINE_WIDTH,
                  "stroke-opacity": LINE_OPACITY
                },
                geometry: {
                  type: "LineString",
                  coordinates: lines
                }
              });
            } else { // typeが連続する場合は設定されたポリラインのパスを繋げていく
              let lastLinkData = links[links.length - 1];
              lastLinkData.geometry.coordinates = lastLinkData.geometry.coordinates.concat(lines)
            }
            return {links, beforeType:type };
          }, {links: [], beforeType: ""}).links;

          // ポイントも入れてみる
          let points = link.reduce((features, {info, path}, idx)=>{
            let {from} = convertPathToFromToPoint(path);
            if(!from) return features; // ポイントがないとアイコンの置きようが無いので何もしない
            let beforeLine = link[idx - 1];
            let afterLine = link[idx + 1];
            let isNearViaPoint = [beforeLine, link[idx], afterLine].some(line=> {
              if(line && line.info ){
                return line.info.guide_type === "7"
              }else{
                return false;
              }
            });
            let beforeInfo = beforeLine && beforeLine.info? beforeLine.info: null;
            if(isNodeMarker(info, beforeInfo) && !isNearViaPoint){ // 経由地前後のポイントの場合はを表示しない
              let {lat, lon} = from;
              let {y, x} = MapionDatumUtil.tky.wgs({y: lat, x: lon});
              // ポイントを入れる？
              features.push({
                "type": "Feature",
                "properties": info,
                "geometry": {
                  "coordinates": [
                    x,
                    y
                  ],
                  "type": "Point"
                }
              });
            }
            return features;
          }, []);

          const geojson = { // geojsonと言いながらfeaturesで区別する ※maplibreのpolylineとpointは区別してレンダリングしかできないため
            polyLineFeatures: features,
            pointFeatures: points
          };

          if(isTablet){
            setIsSmp(true);
          }

          // 検索結果のURLパラメータを設定する
          setNaviURLParam()
          setNaviSearch({ ...naviSearch, driveResult:geojson, driveResultData:route});
          setResultError("");

          setTimeout(()=>{
            window.$(".navi-result-component").scrollTop(0); // 結果のスクロール位置をTOPに戻す
          }, SCROLL_DELAY_TIME);
        },
        error: function(xhr, status, error) {
          console.error("ルート検索エラー:", error);
          setResultError("driveAPIError");
        }
      }).always(function() {
        window.jqXHR = null;
      });
    }
  }

  /*
  * ここからが表示関連のメイン処理
  */
  let vias = [naviVia1, naviVia2 ,naviVia3 ,naviVia4 ,naviVia5];
  // 経由地に違いがある場合は再検索する ※ このdriveResultコンポーネントに来ている状態はすでに発着があり検索ができる状態
  let reSearch = false;
  vias.forEach((via, i)=>{
    // vias[i] === oldvias[i]; // 同じだったらOK = 検索しない
    // vias[i] === null && oldvias[i] === null; // 両方とも空だったらOK = 検索しない

    // 古いほうがない場合は経由地が追加されたので再検索
    // ※いきなり項目がnullになる仕組みではないので今はあり得ない
    // if(vias[i] && oldvias[i] === null){
    //   var {name: nName, lat: nLat, lon: nLon} = vias[i];
    //   if((nName && nLat && nLon)){
    //     reSearch = true;
    //   }
    // }
    // 新しい方がない場合は経由地が削除されたのでそれはそれで再検索
    // ※いきなり項目がnullになる仕組みではないので今はあり得ない
    // if(vias[i] === null && oldvias[i]){
    //   var {name: oName, lat: oLat, lon: oLon} = oldvias[i];
    //   if(oName && oLat && oLon ){
    //     reSearch = true;
    //   }
    // }

    // 新旧を比べて違いがある場合は再検索
    if(vias[i] && oldvias[i]){
      var {name: nName, lat: nLat, lon: nLon, delForClearBtn} = vias[i];
      var {name: oName, lat: oLat, lon: oLon} = oldvias[i];
      // 新しい内容が検索できる状況になったら再検索
      if((nName && nLat && nLon) && (nName!==oName || nLat!==oLat || nLon!==oLon)){
        reSearch = true;
      }

      // 古が検索できる状態だったのが新で検索できない状態になったら
      // 経由地が削除されたことに等しいので再検索※経由地が削除された状態で検索される
      if((oName && oLat && oLon) && (nName && !(nLat && nLon))){
        reSearch = true;
      }

      // フォームの「✕」ボタンでnameが消されたら再検索する
      if(delForClearBtn){
        reSearch = true;
        vias[i].delForClearBtn = false; // ループしてしまうのでフラグを落としておく
      }

    } else if(!vias[i] && oldvias[i]){
      // 旧があり、新がある場合はその経由地が削除された
      var {name: oName, lat: oLat, lon: oLon} = oldvias[i];
      if(oName && oLat && oLon){ // 検索できる状態から削除されたら、経由地が一つ減ってるので再検索する
        reSearch = true;
      }
    }
  });

  oldvias = vias; // 経由地の再検索の判定が終わったのでoldviasに現状のviasを設定
  if(reSearch || naviSearch.reSearchFlag){
    // 検索結果を削除して次のレンダーで再検索する
    setNaviSearch({ ...naviSearch, driveResult: null, driveResultData: null, resultRendered: false, reSearchFlag: false });
  }

  // データがないときは検索を実行する
  if(!naviSearch.driveResult && resultError === ""){
    execSearch();
    return (
      <div className="navi-result-component">
        読み込み中
      </div>
    );
  } else if(resultError === "driveAPIError"){
    return (
      <div className="navi-result-component">
        ドライブルートの検索が失敗しました。時間を置いてから再度検索してください。
      </div>
    );
  } else if(naviSearch.driveResultData && (!naviSearch.driveResultData.links?.link
                                          || naviSearch.driveResultData.status?.distance === "0")
  ){ // ドライブデータのlinkが空の場合や、距離が0の場合はエラー扱いにする
    return (
      <div>ルート検索ができませんでした。<br />検索条件を変更して再度お試しください。</div>
    )
  }

  /*
   * 移動時間と料金の総合表示
  */
  const renderRouteInfo = (route, sumDistance) => {
    let durationMin = getDriveTotalMinTime(route.links.link);
    let hrs = Math.floor(durationMin/60);
    let mns = durationMin % 60;
    let durationString = hrsMnsToJiFunStr({hrs, mns})
    let toll = route.status.toll;

    return (
      <div className="navi-info">
        <div className="navi-info-wrap">
          <div className="navi-info-left">
            <div className="navi-info-num">経路</div>
            <div className="navi-info-icon"><span className="navi-list-car"></span></div>
          </div>
          <div className="navi-info-right">
            <div className="navi-info-time">{durationString}<span className="navi-info-sub">（{sumDistance}）</span></div>
            {
              toll !== "0"
                ? <div class="navi-info-other">料金：{toll}円</div>
                : ""
            }
          </div>
        </div>
      </div>
    )
  }

  /*
   * ポイント間のラインのリスト表示
  */
  const renderLine = (line, sumDistance)=>{
    let {info} = line;
    let {link_name, boundFor} = info;
    let lineView = {
      link_name: typeof link_name === "string" ? link_name: "",
      distance: sumDistance? meterToKmStr(sumDistance): null,
      listColor: _isHighway(info) || _isTollRoad(info)? LIST_COLOR_HIGHWAY : LIST_COLOR_GENERAL_ROAD
    }

    if(typeof boundFor === "string"){
      lineView.hasBoundFor = true;
      lineView.boundFor = boundFor;
    }

    return (<div className="navi-line navi-line-car" onClick={fitPointToPoint}>
      <p className="navi-line-left-info"></p>
      <div className="navi-line-icon" style={{borderLeft: `6px solid ${lineView.listColor}`}}></div>
      <p className="navi-line-name">
        {
          lineView.distance
            ? <span className="navi-line-distance" style={{color: lineView.listColor}} >{lineView.distance}</span>
            : null
        }
        {lineView.link_name}
      </p>
    </div>);
  }

  /*
   * ポイントのリスト表示
  */
  const renderPointFrom = (line, isStart = false, beforeLine = {}) => {
    // ポイントの戦闘の緯度経度を抽出
    let {path, info} = line;
    let {cross_name, link_id} = info;
    let [f60lon, f60lat] = path.split(",");
    let [tkyLat, tkyLon] = [f60lat, f60lon].map(coord => parseFloat(coord) * ONE_OVER_MILLISECONDS_PER_DEGREE);
    let {x: wgsLon, y: wgsLat} = MapionDatumUtil.tky.wgs({y: tkyLat, x: tkyLon});
    let name = typeof cross_name === "string"
      ? cross_name
      : nodeMarkerTypeString(info, beforeLine.info);
    let direction = "";
    if(_isHighway(info) || _isTollRoad(info)){
      if(_isSwitchFromtGeneralToHighway(info, beforeLine.info)){
        direction = nodeMarkerDirection(info.direction);
      } else {
        direction = nodeMarkerHighwayType(info);
      }
    } else { 
      direction = nodeMarkerDirection(info.direction);
    }
    let directionSrc = direction !== ""
      ? `https://www.mapion.co.jp/f/mapion_map/img/navi/drive_icon_${direction}.png`
      : "";

    return (
      <div className="navi-spot" data-lat={wgsLat} data-lon={wgsLon} data-link_id={link_id} >
        <p class="navi-spot-icon">
          {
            directionSrc
              ? <img src={directionSrc} alt="" />
              : <span class="navi-icon-highway-inner">　</span>
          }
        </p>
        <p onClick={(e)=> moveCenter(e, wgsLat, wgsLon)} class="navi-spot-name"><a onClick={(e)=> e.preventDefault()} href="#" data-lat="{lat}" data-lon="{lon}">{name}</a></p>
      </div>
    );
  }

  const renderViaPointFrom = (via) =>{
    let {name, lat, lon} = via;
    return (
      <div className="navi-spot navi-spot-via" data-lat={lat} data-lon={lon}>
        <p className="navi-spot-icon">
          <span className="navi-icon-inner">経</span>
        </p>
        <p className="navi-spot-name" onClick={(e)=> moveCenter(e, lat, lon)}>
          <a href="#">{name}</a>
        </p>
      </div>
    )
  }

  let link = [];
  let lines = [];
  let routeInfo = "";
  if(naviSearch.driveResultData){
    let route = naviSearch.driveResultData;
    let {links: {link: linkData}} = route;
    link = linkData;

    // 合計距離や時間の処理
    let totalDistanceString = totalDistance(link)
    routeInfo = renderRouteInfo(route, totalDistanceString);

    // リスト用の表示用データを作る
    let sumDistance = 0;
    let lastNodeMarkerLine = null;
    let view = {lines: []};
    lines = view.lines;
    let filterVias = vias.filter(v=>{
      return v && v.lon
    });

    lines = link.reduceRight((lines, line, idx)=>{
      let info = line.info;
      let {link_type, distance} =  info;
      if(link_type !== "15"){ // 発〜最初のポイントと着〜末端のポイントは加算しない
        sumDistance = sumDistance + Number(distance);
      }
      let beforeLine = link[idx -1] || null;
      let beforeInfo = beforeLine ? beforeLine.info : null;
      let beforeGuide_type = beforeInfo? beforeInfo.guide_type : null;
      if(isNodeMarkerListPoint(info, beforeInfo) || beforeGuide_type === "7"){
        line.sumDistance = sumDistance;
        
        lines.unshift(renderLine(line, sumDistance)); // lineとポイントとして扱う
        
        if(beforeLine.info.guide_type === "7"){
          let via = filterVias.pop();
          if(via && via.name && via.lat && via.lon){ // 経由地をドラッグ移動した瞬間に name=lat=lon=nullの瞬間があるのでちゃんと中身あるか判定する
            lines.unshift(renderViaPointFrom(via)); // 経由地のポイントを設定
          }
        } else {
          lines.unshift(renderPointFrom(line, false, beforeLine)); // ポイントを設定
        }

        lastNodeMarkerLine = beforeLine // start前の直近のNodeMarkerのデータを保持しとく
        sumDistance = 0; // ノード間の合計距離を初期化
      }

      // IPCのデータの場合はstartの次のノードで角度が無く、NodeMarkerに引っかからないので先頭までの距離が出ない
      // なので、startの次のNodeMarkerからstartまでの距離を意図的に作成する必要あり
      let [firstLine] = link;
      if(firstLine === line){
        let targetLine = lastNodeMarkerLine || beforeLine || line;
        targetLine.sumDistance = sumDistance;
        lines.unshift(renderLine(targetLine, sumDistance))
      }
      return lines;
    }, lines);
  }
  var {name: startName, lat:startLat, lon: startLon} = naviStart;
  var {name: endName, lat:endLat, lon:endLon} = naviEnd;

  return (
    <div className="navi-drive-result">
      <div className="navi-info-wrapper" onClick={()=> naviToggle(true)}>
      {routeInfo}
      </div>
      <div className="navi-route">
        <div className="navi-spot navi-spot-start" data-lat={startLat} data-lon={startLon}>
          <p className="navi-spot-icon"><span className="navi-icon-inner">発</span></p>
          <p onClick={(e)=> moveCenter(e, startLat, startLon)} className="navi-spot-name"><a onClick={(e)=> e.preventDefault()} href="#" data-lat={startLat} data-lon={startLon}>{startName}</a></p>
        </div>
        {lines}
        <div className="navi-spot navi-spot-end" data-lat={endLat} data-lon={endLon}>
          <p className="navi-spot-icon"><span className="navi-icon-inner">着</span></p>
          <p onClick={(e)=> moveCenter(e, endLat, endLon)} className="navi-spot-name"><a onClick={(e)=> e.preventDefault()} href="#" data-lat={endLat} data-lon={endLon}>{endName}</a></p>
        </div>
      </div>
    </div>
  );
};

export default DriveResult;
